import { useEffect } from 'react';
import { useAppContext } from '@/context/context';
import usePageTracking from '@/hooks/usePageTracking';

const TitleUpdater = ({ isPublic = false }: { isPublic?: boolean }) => {
  const { selectedNav } = useAppContext() || { selectedNav: { primary: '' } };
  usePageTracking();

  useEffect(() => {
    const authPages = [
      '/',
      '/login',
      '/login-mfa',
      '/login-world',
      '/register',
      '/register/choose',
      '/register-world',
      '/shaliach-registration',
      '/candidate-registration',
      '/privacy-policy',
      '/delete-account',
      '/apphome'
    ];
    const endTitle = !isPublic || authPages.includes(selectedNav?.link) ? 'שלוחים-אפ' : 'חב"ד ישראל';
    let title = selectedNav?.primary;

    if (selectedNav?.primary === 'שלוחים-אפ' || selectedNav?.primary === 'חב"ד ישראל') {
      title = endTitle;
    } else {
      title = `${title} - ${endTitle}`;
    }
    document.title = title;
  }, [selectedNav?.primary, selectedNav?.link, isPublic]);

  return null;
};

export default TitleUpdater;
